import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

import Icon from "components/Icon/Icon"
import { FormField } from "components/Form"

export default function AdultPassenger({ data, index, remove }) {
  const { t } = useTranslation()

  return (
    <div className="row">
      <FormField
        fieldType="input"
        type="hidden"
        name={`passengers[${index}].passengerId`}
        label=""
        defaultValue={data.id || data.passengerId}
      />
      <FormField
        fieldType="input"
        type="hidden"
        name={`passengers[${index}].passengerType`}
        label=""
        defaultValue="ADULT"
      />
      <div className="col-12 col-xl-4">
        <div className="row">
          <div className="col-1 my-auto text-center">
            <b>{`${index + 1}.`}</b>
          </div>
          <div className="col-6">
            <FormField
              fieldType="input"
              type="text"
              name={`passengers[${index}].familyReference`}
              label={t("Family reference")}
              defaultValue={data.familyReference}
            />
          </div>
          <div className="col-5">
            <FormField
              fieldType="select"
              name={`passengers[${index}].type`}
              label={t("Passenger type")}
              options={[{ id: "ADULT", displayName: t("Adult") }]}
              disabled
              defaultValue={{ id: "ADULT", displayName: t("Adult") }}
            />
          </div>
        </div>
      </div>
      <div className="col-12 col-xl-8">
        <div className="row">
          <div className="col-3">
            <FormField
              fieldType="input"
              type="text"
              name={`passengers[${index}].firstName`}
              label={t("First name")}
              required
              defaultValue={data.firstName}
            />
          </div>
          <div className="col-3">
            <FormField
              fieldType="input"
              type="text"
              name={`passengers[${index}].lastName`}
              label={t("Last name")}
              required
              defaultValue={data.lastName}
            />
          </div>
          <div className="col-6">
            <div className="row">
              <div className="col-5">
                <FormField
                  fieldType="select"
                  name={`passengers[${index}].gender`}
                  label={t("Gender")}
                  options={[
                    { id: "F", displayName: t("Female") },
                    { id: "M", displayName: t("Male") },
                  ]}
                  required
                  defaultValue={data.gender}
                />
              </div>
              <div className="col-5">
                <FormField
                  fieldType="date"
                  name={`passengers[${index}].dateOfBirth`}
                  label={t("Date of birth")}
                  defaultValue={data.dateOfBirth}
                />
              </div>
              <div className="col-auto my-auto text-center pt-1">
                <Icon
                  color="danger"
                  name="remove"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    remove(index)
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

AdultPassenger.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]).isRequired,
  remove: PropTypes.func.isRequired,
}
